import React, { Component } from "react";
import { Link } from "react-router-dom";
import AdminHeader from "../Header/AdminHeader";
import AdminFooter from "../Footer/AdminFooter";
import AdminLeftMenu from "../Navbar/AdminLeftMenu";
import EmptyImg from "../Dashboard/assets/img/create-project.png";
import { userloginDetails } from "../Utils/AdminAuth";
import { HOST_URL } from "../Dashboard/api/Api";

class UserTransationDetails extends Component {
  constructor() {
    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const empType = lStorage.user.isAdmin;
    const permissionsubadmin = lStorage?.permission?.per_value?.usermanagement?.children

    super();

    this.state = {
      user_id: userId,
      token: userToken,
      emp_type: empType,
      permissionsubadmin: permissionsubadmin,
      successMessage: false,
      selectUserTransactionDetails: "",
      seletedUserId: "",
      selectedUserType: "",
      errorMessage: "",
      bgColor: "alert alert-success alert-dismissible",
    };
  }

  componentDidMount() {
    this.getUserDetails();
    this.setState({
      seletedUserId: this.props.match.params.id,
      selectedUserType: this.props.match.params.userType,
    });

    // --- Transaction API (POST) ---
    fetch(`${HOST_URL}/admin_user_list.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user_id: this.state.user_id,
        method: "retrieve",
        type: "transaction",
        ret_user_id: this.props.match.params.id,
        token: this.state.token,
      }),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success === true) {
          this.setState({ selectUserTransactionDetails: result.data });
        } else {
          this.setState({
            successMessage: true,
            successBg: "alert alert-danger alert-dismissible",
            errorMessage: result.message,
          });
        }
      })
      .catch(() => {
        this.setState({
          successMessage: true,
          successBg: "alert alert-danger alert-dismissible",
          errorMessage: "Something went wrong. Please try again later.",
        });
      });
  }

  getUserDetails() {
    this.setState({ seletedUserId: this.props.match.params.id });

    // --- User Details API (POST) ---
    fetch(`${HOST_URL}/admin_user_list.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user_id: this.state.user_id,
        method: "retrieve",
        type: "userdetails",
        ret_user_id: this.props.match.params.id,
        token: this.state.token,
      }),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success === true) {
          this.setState({
            email: result.data[0].email,
          });
        } else {
          this.setState({
            successMessage: true,
            successBg: "alert alert-danger alert-dismissible",
            errorMessage: result.message,
          });
        }
      })
      .catch(() => {
        this.setState({
          successMessage: true,
          successBg: "alert alert-danger alert-dismissible",
          errorMessage: "Something went wrong. Please try again later.",
        });
      });
  }


  render() {
    console.log(this.state.permissionsubadmin);
    return (
      <div className="wrapper">
        <AdminLeftMenu />
        <div className="main">
          <AdminHeader />
          <main className="content">
            <div className="container-fluid p-0">
              <div className="row mb-2 mb-xl-3">
                <div className="col-auto d-none d-sm-block">
                  <h3>
                    User Details{" "}
                    <strong className="text-info"> {this.state.email} </strong>{" "}
                  </h3>
                </div>
              </div>
              <div className="row">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <div >
                        <nav className="text-center" aria-label="breadcrumb">
                          <ol className="breadcrumb bg-transparent p-0 mt-1 mb-0">
                            <Link
                              to={
                                "/admin/user-details/" +
                                this.state.seletedUserId +
                                `/` +
                                this.state.selectedUserType
                              }
                            >
                              <li className="breadcrumb-item">User Details </li>{" "}
                            </Link>

                            {(this.state.emp_type === "admin" || this.state.emp_type === "emp" || this.state.emp_type === "reseller" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.transactiondetails)) &&
                              <Link
                                to={
                                  "/admin/user-transaction-details/" +
                                  this.state.seletedUserId +
                                  `/` +
                                  this.state.selectedUserType
                                }
                              >
                                {" "}
                                <li className="breadcrumb-item active">
                                  {" "}
                                  Transaction Details{" "}
                                </li>
                              </Link>}

                            {(this.state.emp_type === "admin" || this.state.emp_type === "emp" || this.state.emp_type === "reseller" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.addeditprice)) &&
                              <Link
                                to={
                                  "/admin/user-price-details/" +
                                  this.state.seletedUserId +
                                  `/` +
                                  this.state.selectedUserType + `?` + "channel=whatsapp"
                                }
                              >
                                <li className="breadcrumb-item"> Add Price </li>
                              </Link>}

                            {(this.state.emp_type === "admin" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.awssettings)) && (
                              <Link
                                to={
                                  "/admin/aws-settings/" +
                                  this.state.seletedUserId +
                                  `/` +
                                  this.state.selectedUserType + `?` + "channel=whatsapp"
                                }
                              >
                                <li className="breadcrumb-item"> AWS Settings </li>
                              </Link>
                            )}
                            {(this.state.emp_type === "admin" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.billingmode)) && (
                              <Link
                                to={
                                  "/admin/user-billing-mode/" +
                                  this.state.seletedUserId +
                                  `/` +
                                  this.state.selectedUserType
                                }
                              >
                                {" "}
                                <li className="breadcrumb-item">
                                  {" "}
                                  Billing Mode{" "}
                                </li>
                              </Link>
                            )}

                            {(this.state.emp_type === "admin" || this.state.emp_type === "emp" || this.state.emp_type === "reseller" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.addeditcredit)) && <Link
                              to={
                                "/admin/user-add-price/" +
                                this.state.seletedUserId +
                                `/` +
                                this.state.selectedUserType
                              }
                            >
                              {" "}
                              <li className="breadcrumb-item">
                                {" "}
                                Add Credit{" "}
                              </li>
                            </Link>}

                            {this.state.emp_type === "reseller" ? null : (
                              <>


                                {(this.state.emp_type === "admin" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.entitybypass)) && <Link
                                  to={
                                    "/admin/user-entity-pass/" +
                                    this.state.seletedUserId +
                                    `/` +
                                    this.state.selectedUserType
                                  }
                                >
                                  {" "}
                                  <li className="breadcrumb-item">
                                    {" "}
                                    Entity By Pass{" "}
                                  </li>
                                </Link>}

                                {(this.state.emp_type === "admin" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.changecurrency)) &&
                                  <Link
                                    to={
                                      "/admin/change-currency/" +
                                      this.state.seletedUserId +
                                      `/` +
                                      this.state.selectedUserType
                                    }
                                  >
                                    {" "}
                                    <li className="breadcrumb-item ">
                                      {" "}
                                      Change Currency{" "}
                                    </li>
                                  </Link>}

                                {(this.state.emp_type === "admin" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.bulksmsroutesetting)) &&
                                  <Link
                                    to={
                                      "/admin/bulk-sms-route/" +
                                      this.state.seletedUserId +
                                      `/` +
                                      this.state.selectedUserType
                                    }
                                  >
                                    {" "}
                                    <li className="breadcrumb-item ">
                                      {" "}
                                      Bulk Sms Route Setting{" "}
                                    </li>
                                  </Link>}


                                {(this.state.emp_type === "admin" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.autoshorturl)) &&
                                  <Link
                                    to={`/admin/api-auto-short-url/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                  >
                                    <li className="breadcrumb-item">
                                      Auto Short URL
                                    </li>
                                  </Link>}
                                {/* {this.state.emp_type === "admin" &&
                                  <Link
                                    to={`/admin/extra-settings/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                  >
                                    <li className="breadcrumb-item">
                                      Extra Settings
                                    </li>
                                  </Link>} */}
                                {((this.state.emp_type === "admin" || this.state.emp_type === "emp" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.extrasettings))) &&
                                  <Link
                                    to={`/admin/extra-settings/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                  >
                                    <li className="breadcrumb-item">
                                      Extra Settings
                                    </li>
                                  </Link>}
                                {(this.state.emp_type === "admin" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.mmlite)) &&
                                  <Link
                                    to={`/admin/mmlite/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                  >
                                    <li className="breadcrumb-item">
                                      MMLite
                                    </li>
                                  </Link>}
                                {(this.state.emp_type === "admin" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.ai_bot)) &&
                                  <Link
                                    to={`/admin/ai-bot/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                  >
                                    <li className="breadcrumb-item">
                                      AI Bot
                                    </li>
                                  </Link>}

                                {(this.state.emp_type === "admin" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.edituserplan)) &&
                                  <Link
                                    to={`/admin/edit-user-plan/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                  >
                                    <li className="breadcrumb-item">
                                      Edit User Plan
                                    </li>
                                  </Link>}
                                {/* {this.state.emp_type === "admin" &&
                                  <Link
                                    to={`/admin/ivr-setting/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                  >
                                    <li className="breadcrumb-item">
                                      IVR Setting
                                    </li>
                                  </Link>} */}
                              </>
                            )}
                          </ol>
                        </nav>
                      </div>
                    </h5>
                  </div>

                  <div className="card-body">
                    <div className="row">
                      <div className="col-12 col-lg-12 col-xxl-12 d-flex">
                        <div className="card table-responsive flex-fill">
                          {this.state.selectUserTransactionDetails ? (
                            <table className="table  table-hover my-0">
                              <thead>
                                <tr>
                                  <th>Remark</th>
                                  <th>Description</th>
                                  <th className="">Amount</th>
                                  <th className="">Transaction</th>
                                  <th className="">Status</th>
                                  <th className="">Created Date / Time</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.selectUserTransactionDetails.map(
                                  (item, i) => (
                                    <tr key={i}>
                                      <td
                                        style={{
                                          color:
                                            item.amount < 0 ? "red" : "green",
                                        }}
                                      >
                                        {item.remark !== null ? (
                                          item.remark
                                        ) : (
                                          <span>N/A</span>
                                        )}
                                      </td>
                                      <td
                                        style={{
                                          color:
                                            item.amount < 0 ? "red" : "green",
                                        }}
                                      >
                                        {item.description !== "" ? (
                                          item.description
                                        ) : (
                                          <span>N/A</span>
                                        )}
                                      </td>
                                      <td
                                        style={{
                                          color:
                                            item.amount < 0 ? "red" : "green",
                                        }}
                                      >
                                        {item.amount}
                                      </td>
                                      <td
                                        style={{
                                          color:
                                            item.amount < 0 ? "red" : "green",
                                        }}
                                      >
                                        {item.transaction_id}
                                      </td>
                                      <td>
                                        {item.status === 1 ? (
                                          <span className="badge bg-success">
                                            {" "}
                                            Success{" "}
                                          </span>
                                        ) : item.status === 0 ? (
                                          <>
                                            <span className="badge bg-info">
                                              {" "}
                                              Pending{" "}
                                            </span>
                                          </>
                                        ) : (
                                          <span className="badge bg-danger">
                                            {" "}
                                            Failed{" "}
                                          </span>
                                        )}
                                      </td>

                                      <td
                                        style={{
                                          color:
                                            item.amount < 0 ? "red" : "green",
                                        }}
                                      >
                                        {item.created}
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          ) : (
                            <div className="text-center">
                              <div className="card-body">
                                <img
                                  alt="Empty Data"
                                  className="project-empty-img"
                                  src={EmptyImg}
                                />
                                <p>No Any Transaction Details Found</p>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
          <AdminFooter />
        </div>
      </div>
    );
  }
}

export default UserTransationDetails;
